import React, { useState, useEffect } from "react";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import { Grid } from "@mui/material";

// External Link Guard Component
export default function ExternalLinkWarning(props: {
  option: boolean;
  setExternalWarning: any;
  handleSelection: any;
  selectedUrl: string;
}) {
  const { option, setExternalWarning, handleSelection, selectedUrl } = props;
  const [open, setOpen] = useState(option);

  useEffect(() => {
    setOpen(option);
  }, [option]);

  const handleClose = (event: any) => {
    if (event.target.id !== "") handleSelection(event.target.id);
    setExternalWarning(false);
    setOpen(false);
  };

  return (
    <div>
      <Dialog open={open} onClose={handleClose}>
        <DialogTitle style={{ cursor: "move" }} id="draggable-dialog-title">
          External Link
        </DialogTitle>
        <DialogContent>
          <Grid container>
            <Grid item xs={12}>
              <span>You'll be redirected to</span>
            </Grid>
            <Grid item xs={12}>
              <span>{selectedUrl}</span>
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions>
          <Button disableRipple autoFocus id={"Cancel"} onClick={handleClose}>
            Cancel
          </Button>
          <Button disableRipple onClick={handleClose} id={"Confirm"}>
            Confirm
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}
